import {Component, Input, OnInit} from '@angular/core';
import {LifeProject} from '../../../class/lifeproject/life-project';

@Component({
  selector: 'app-life-project-tab',
  templateUrl: './life-project-tab.component.html',
  styleUrls: ['./life-project-tab.component.css']
})
export class LifeProjectTabComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  lifeProjectType: number;

  @Input()
  lifeProjects: LifeProject[];

  constructor() {
  }

  ngOnInit() {
  }

  get filterProjects() {
    return this.lifeProjects.filter(value => value.type == this.lifeProjectType);
  }
}
